export default __webpack_public_path__ + "static/media/logo_semanggi.f46b96d5.png";